export type {
  AISectorCarouselProps,
  AISectorTableProps,
  AISectorItemProps,
} from "./AISectorCarouselProps";
export { AISectorCarousel } from "./AISectorCarousel";
